import SbuxDialog2 from "../../../../components/SbuxDialog2";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { useAppDispatch } from "../../../../store/types";
import { deleteMediaMgt } from "../../../../services/mediaMgt";

interface Props {
  row: Record<string, unknown>;
  title: string;
  name: string;
  open: boolean;
  toggleOpen: () => void;
}

const MediaMgtDeleteDialog = ({
  row,
  title,
  name,
  open,
  toggleOpen,
}: Props) => {
  const dispatch = useAppDispatch();

  const handleOkayClick = async () => {
    const deleteObj = {
      mediaId: row.mediaId as string,
      language: row.language as string,
      filePath: row.filePath as string,
      languageCode: row.languageCode as string,
      type: row.type as string,
    };
    await dispatch(deleteMediaMgt(deleteObj as Record<string, unknown>));
  };

  const dialogConfig = {
    title,
    hasBackdrop: false,
    asModal: true,
  };

  return (
    <SbuxDialog2 open={open} config={dialogConfig} handleOnClose={toggleOpen}>
      <DialogContent dividers>
        <Typography variant="h5">
          <SbuxTranslate>{`Are you sure you want to delete `}</SbuxTranslate>
          <span>{`${name}?`}</span>
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box className="actionContainer">
          <Button variant="contained" size="medium" onClick={handleOkayClick}>
            <SbuxTranslate>{`Okay`}</SbuxTranslate>
          </Button>
          <Button variant="outlined" size="medium" onClick={toggleOpen}>
            <SbuxTranslate>{`Cancel`}</SbuxTranslate>
          </Button>
        </Box>
      </DialogActions>
    </SbuxDialog2>
  );
};

export default MediaMgtDeleteDialog;
